import { Link, Text } from 'components'

export default function ReCaptchaInfo() {
  return (
    <Text fontFamily="Inter" fontSize="xs" color="gray.500" mx={4} textAlign="center">
      This site is protected by reCAPTCHA and the Google{' '}
      <Link href="https://policies.google.com/privacy" color="blue" target="_blank">
        Privacy Policy
      </Link>{' '}
      and{' '}
      <Link href="https://policies.google.com/terms" color="blue" target="_blank">
        Terms of Service
      </Link>{' '}
      apply.
    </Text>
  )
}
